import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { notificationsByIdDeleteSlice } from './@async/delete';
import { notificationsByIdPatchSlice } from './@async/patch';

export const notificationsByIdReducers = combineReducers({
	delete: notificationsByIdDeleteSlice.asyncReducers,
	patch: notificationsByIdPatchSlice.asyncReducers
});

export const watchNotificationsByIdSagas = combineAllWatchers([
	notificationsByIdDeleteSlice.asyncWatchers,
	notificationsByIdPatchSlice.asyncWatchers
]);
